import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as contractorsActions from '../actions/contractorsActions';
import ContractorsForm from '../components/ContractorsForm';
import { FormType } from '../../shared/model/FormType';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class ContractorsEditScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.CONTRACTORS,
            Breadcrumbs.CONTRACTORS_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.contractorsActions.fetchContractor(id);
    }

    componentWillUnmount() {
        this.props.contractorsActions.clearContractors();
    }

    componentDidUpdate(prevProps) {
        const { location, contractor: currentContractor } = this.props;
        const { contractor: prevContractor } = prevProps;

        if ( currentContractor !== prevContractor ) {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.CONTRACTORS_DETAIL.id,
                url: location.pathname,
                description: currentContractor.name,
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { breadcrumbs } = this.state;
        const { contractor, contractorLoading } = this.props;

        return (
            <PsPage title={I18nUtils.tr('TR_CONTRATISTA')} breadcrumbs={breadcrumbs}>
                <ContractorsForm
                    type={FormType.UPDATE}
                    contractor={contractor}
                    loading={contractorLoading}
                />
            </PsPage>
        );
    }

}

const mapStateToProps = (state) => {
    const {
        contractor,
        contractorLoading,
    } = state.contractors;

    return {
        contractor,
        contractorLoading,
    };
};

const mapDispatchToProps = dispatch => ( {
    contractorsActions: bindActionCreators(contractorsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorsEditScreen);



// WEBPACK FOOTER //
// ./src/app/contractors/screens/ContractorsEditScreen.js